import { useTranslation } from 'react-i18next'
import { Button, List, ListItem, ListItemText, Typography } from '@mui/material'

import { ModalWrapper } from '../modal-wrapper'
import { IItemDetails, IItemsRemoveConfirmModalValues } from 'src/types'

import { useStyles } from './styles'
import { Loader } from '../loader'

interface IItemsRemoveConfirmModal {
  customModal: IItemsRemoveConfirmModalValues['customModal']
  open: boolean
  handleClose: () => void
  itemsDetails?: IItemDetails[]
  handleConfirm?: () => void | Promise<void>
  isLoadingModal: boolean
}

const ActionConfirmModal = ({
  open,
  customModal,
  handleClose,
  itemsDetails = [],
  handleConfirm,
  isLoadingModal,
}: IItemsRemoveConfirmModal) => {
  const [t] = useTranslation()
  const classes = useStyles()

  if (!customModal || !handleConfirm) return null

  const handleConfirmClick = async () => {
    await handleConfirm()
    handleClose()
  }

  return (
    <ModalWrapper open={open} onClose={handleClose} className={classes.modalWrapper}>
      <div>
        <Typography className={classes.title}>{customModal.title}</Typography>
        <Typography>{customModal.secondaryText}</Typography>

        {itemsDetails.length > 0 && (
          <List dense>
            {itemsDetails.map(({ title, text }) => (
              <ListItem key={title} sx={{ display: 'block' }} disableGutters>
                <ListItemText
                  primaryTypographyProps={{ className: classes.itemTitle }}
                  primary={`${title}:`}
                />
                <Typography className={classes.relationsTitle}>{text}</Typography>
              </ListItem>
            ))}
          </List>
        )}
        {!!customModal.content && customModal.content}
      </div>
      <div className={classes.buttonsWrapper}>
        <div className={classes.buttonWrapper}>
          <Button fullWidth variant="outlined" onClick={handleClose} disabled={isLoadingModal}>
            {t('cancel-button-text.v')}
          </Button>
        </div>
        <div className={classes.buttonWrapper}>
          <Button
            fullWidth
            variant="contained"
            onClick={handleConfirmClick}
            disabled={isLoadingModal}
          >
            <Typography sx={{ mr: isLoadingModal ? '8px' : 0 }}>
              {customModal?.confirmButtonText ? customModal.confirmButtonText : 'Confirm'}
            </Typography>

            {isLoadingModal && <Loader isStatic size={18} />}
          </Button>
        </div>
      </div>
    </ModalWrapper>
  )
}

export { ActionConfirmModal }
